export const customTypeKeys = {
  all: () => ["customTypes"],
  single: (id) => [...customTypeKeys.all(), id]
};

export const customValueKeys = {
  single: (id: number, profileId: number) => ["customValues", id, profileId]
};
